module.exports = __webpack_public_path__ + "media/开心点点消.07b2c1fa.mp4";